import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecuritiesPropertyService } from 'src/app/services/securities-property/securities-property.service';
import { MessageUtil } from 'src/app/utils/message.util';

@Component({
  selector: 'app-liberar-convite-gratis-dialog',
  templateUrl: './liberar-convite-gratis-dialog.component.html',
  styleUrls: ['./liberar-convite-gratis-dialog.component.scss'],
})
export class LiberarConviteGratisDialogComponent implements OnInit {
  securitiesPropertyId: number | null = null;
  date: Date | null = null;
  qty: number | null = null;

  constructor(
    private config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
    private securitiesPropertyService: SecuritiesPropertyService,
    private spinner: NgxSpinnerService,
    private messageUtil: MessageUtil
  ) {}

  ngOnInit(): void {
    this.securitiesPropertyId = this.config?.data?.securitiesPropertyId ?? null;
    this.date = new Date();
    this.qty = null;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.securitiesPropertyId == null) {
      return;
    }
    if (!this.date) {
      this.messageUtil.generateMessage('warning', 'Atenção', 'Informe a data.');
      return;
    }
    if (this.qty == null || this.qty < 1) {
      this.messageUtil.generateMessage(
        'warning',
        'Atenção',
        'Informe o número de convites grátis (mínimo 1).'
      );
      return;
    }
    const d = this.date;
    const dateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(d.getDate()).padStart(2, '0')}`;

    this.spinner.show();
    this.securitiesPropertyService
      .addFreeInviteHistoric({
        securitiesPropertyId: this.securitiesPropertyId,
        date: dateStr,
        numberInviteToBuy: this.qty,
      })
      .subscribe({
        next: () => {
          this.spinner.hide();
          this.messageUtil.generateMessage(
            'success',
            'Sucesso',
            'Convites grátis adicionados com sucesso.'
          );
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.spinner.hide();
          const ex = error?.error?.data?.exception;
          if (ex) {
            this.messageUtil.generateMessage(ex.type, ex.title, ex.message);
          } else {
            this.messageUtil.generateMessage(
              'error',
              'Erro',
              'Não foi possível adicionar os convites grátis.'
            );
          }
        },
      });
  }
}
